import { LitElement, html, css } from '@hh/global.js';

class MyElement extends LitElement {
  static properties = {
    noUiSliderReady: { type: Boolean },
    max: { type: Number },
    min: { type: Number },
    currentMin: {
      type: Number,
      attribute: 'current-min',
    },
    currentMax: {
      type: Number,
      attribute: 'current-max',
    },
  }

  constructor() {
    super()

    this.noUiSliderReady = false
    this.checkNoUiSliderReady()
  }

  get range() {
    return (
      this.shadowRoot.querySelector('slot[name="range"]')?.assignedNodes()[0] ??
      null
    )
  }

  get minInput() {
    return document.querySelector('.js-filter-price-range-min')
  }

  get maxInput() {
    return document.querySelector('.js-filter-price-range-max')
  }

  connectedCallback() {
    super.connectedCallback()

    this.min = 0.0

    if (!this.currentMin) this.currentMin = '0.99'
    if (!this.currentMax) this.currentMax = this.max
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  updated(changedProperties) {
    if (changedProperties.has('noUiSliderReady') && this.noUiSliderReady) {
      this.initNoUiSlider()
    }
  }

  checkNoUiSliderReady() {
    if (typeof noUiSlider === 'undefined') {
      setTimeout(() => {
        this.checkNoUiSliderReady()
      }, 100)
    } else {
      this.noUiSliderReady = true
    }
  }

  initNoUiSlider() {
    this.priceRange = noUiSlider.create(this.range, {
      start: [this.currentMin - 1, this.currentMax - 1],
      connect: true,
      step: 1,
      range: {
        min: this.min,
        max: this.max,
      },
      pips: {
        mode: 'steps',
        filter: (value) => {
          return value % 15 === 0 ? 1 : -1
        },
      },
    })

    this.priceRange.on('change', this.onPriceRangeChange.bind(this))
    this.priceRange.on('update', this.onPriceRangeUpdate.bind(this))

    this.appendPlusLastPipLabel()
  }

  onPriceRangeUpdate(values, handle) {
    this.currentMin = values[0].replace('.00', '.99')
    this.currentMax = values[1].replace('.00', '.99')

    this.updateInRangePips(values, handle)
    if (handle === 1) {
      this.checkIfHandleIsAtMax(values[1])
    }
  }

  async onPriceRangeChange(values, handle) {
    await this.updateComplete
    this.minInput.value = this.currentMin
    this.maxInput.value = this.currentMax
    this.priceRange.disable()
    const form = this.closest('form')
    form.dispatchEvent(new Event('change'))
  }

  appendPlusLastPipLabel() {
    const lastPip = this.querySelector('.noUi-value:last-child')
    const lastPipText = lastPip.textContent

    if (!lastPip) return
    if (this.max === Math.floor(Number(lastPipText))) return
    lastPip.textContent = `${lastPipText}+`
  }

  updateInRangePips(values) {
    const markers = this.querySelectorAll('.noUi-marker')
    const pips = this.querySelectorAll('.noUi-value')

    markers.forEach((marker) => marker.classList.remove('in-range'))

    const min = Number(values[0])
    const max = Number(values[1])

    pips.forEach((pip) => {
      const value = Number(pip.dataset.value)
      if (value + 5 >= min && value - 5 <= max) {
        pip.previousElementSibling.classList.add('in-range')
      }
    })
  }

  checkIfHandleIsAtMax(value) {
    const isAtMax = Math.floor(Number(value)) === Math.floor(this.max)
    this.range.classList.toggle('at-max', isAtMax)
  }

  render() {
    return html`
      <div>
        <slot name="price-range"></slot>
        <slot name="range"></slot>
      </div>
    `
  }

  static styles = css`
    ::slotted(.price-range) {
      margin-bottom: 3rem;
      text-align: center;
    }
  `
}

if (!customElements.get('hh-price-range-toggle')) {
  customElements.define('hh-price-range-toggle', MyElement);
}
